import * as Sentry from "@sentry/remix"

/**
 * Adds a consistent breadcrumb for Shopify cart operations
 * Helps track the sequence of cart operations leading up to errors
 */
export function addShopifyCartBreadcrumb(
  message: string,
  data?: Record<string, any>,
  level: "info" | "warning" | "error" = "info"
) {
  Sentry.addBreadcrumb({
    category: "shopify_cart",
    message,
    level,
    data,
    timestamp: Date.now() / 1000
  })
}

/**
 * Sets cart-related context that will be included in all subsequent Sentry events
 * Should be called when cart state changes
 */
export function setShopifyCartContext(
  cartId?: string,
  data?: Record<string, any>
) {
  Sentry.setContext("shopify_cart", {
    cartId,
    ...data
  })
}

/**
 * Clears the Shopify cart context
 */
export function clearShopifyCartContext() {
  Sentry.setContext("shopify_cart", null)
}
